module.exports = __webpack_public_path__ + "img/de.85f98c37.svg";